import { useEffect } from 'react'
import { AnimatePresence } from 'framer-motion'
import { useDesktopStore } from '@/stores/desktopStore'
import { Preloader } from '@/components/Preloader'
import { DesktopLanding } from '@/components/DesktopLanding'
import { Taskbar } from '@/components/Taskbar'
import { Window } from '@/components/Window'
import { WorkWindow } from '@/windows/WorkWindow'
import { ThoughtsWindow } from '@/windows/ThoughtsWindow'
import { PhotographyWindow } from '@/windows/PhotographyWindow'
import './App.css'

function App() {
  const { isLoading, isDesktopReady, windows, theme } = useDesktopStore()

  // Apply theme to document
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme.isDark ? 'dark' : 'light')
  }, [theme.isDark])

  // Brightness is applied via CSS variable instead of document filter
  useEffect(() => {
    document.documentElement.style.setProperty('--brightness', `${theme.brightness / 100}`)
  }, [theme.brightness])

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Add keyboard shortcuts here
      if (e.key === 'Escape') {
        // Could close active window
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  return (
    <div className="app">
      {/* Preloader */}
      <AnimatePresence>{isLoading && <Preloader />}</AnimatePresence>

      {/* Desktop */}
      {!isLoading && (
        <>
          <DesktopLanding />

          {/* Windows */}
          <AnimatePresence>
            {windows.map((windowState) => {
              if (!windowState.isOpen || windowState.isMinimized) return null

              switch (windowState.id) {
                case 'work':
                  return (
                    <Window key={windowState.id} id="work" className="window--work">
                      <WorkWindow />
                    </Window>
                  )
                case 'thoughts':
                  return (
                    <Window key={windowState.id} id="thoughts" className="window--thoughts">
                      <ThoughtsWindow />
                    </Window>
                  )
                case 'photography':
                  return (
                    <Window key={windowState.id} id="photography" className="window--photography">
                      <PhotographyWindow />
                    </Window>
                  )
                // Control is now rendered as a popup in the Taskbar
                default:
                  return null
              }
            })}
          </AnimatePresence>

          {/* Taskbar */}
          {isDesktopReady && <Taskbar />}
        </>
      )}
    </div>
  )
}

export default App
